module.exports = __webpack_public_path__ + "img/role01.89cf71a0.png";